import { render, staticRenderFns } from "./EvalEvaluation.vue?vue&type=template&id=04488d72&scoped=true"
import script from "./EvalEvaluation.vue?vue&type=script&lang=js"
export * from "./EvalEvaluation.vue?vue&type=script&lang=js"
import style0 from "./EvalEvaluation.vue?vue&type=style&index=0&id=04488d72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04488d72",
  null
  
)

export default component.exports